import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
//import './evaluacionMonitoreo.css';

  const ArmonizacionContable = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
  },[]); 

  return (
    <div className='container'>
        <div className='row'>
            <div className='ldf_titulo'>
                <h2>Armonización Contable</h2>
                <hr className='hr-gob'/>
            </div>

            <table className="table table-striped table-bordered tabla_elementos">
                <tbody>
                    <tr>
                        <td>2015</td>
                        <td>2016</td>
                        <td>2017</td>
                        <td>2018</td>
                        <td>2019</td>
                    </tr>
                    <tr>
                        <td>2020</td>
                        <td><h3><Link to="DetalleArmonizacionContable/DetalleArmonizacionContable2021">2021</Link></h3></td>
                        <td><h3><Link to="DetalleArmonizacionContable/DetalleArmonizacionContable2022">2022</Link></h3></td>
                        <td><h3><Link to="DetalleArmonizacionContable/DetalleArmonizacionContable2023">2023</Link></h3></td>
                        <td><h3><Link to="DetalleArmonizacionContable/DetalleArmonizacionContable2024">2024</Link></h3></td>
                    </tr>
                    <tr>
                        <td><h3><Link to="DetalleArmonizacionContable/DetalleArmonizacionContable2025">2025</Link></h3></td>
                        <td><h3><Link to="DetalleArmonizacionContable/DetalleArmonizacionContable2026">2026</Link></h3></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
         </div>
     </div>
     )
}

export default ArmonizacionContable